module.exports = __webpack_public_path__ + "img/12.480e344c.png";